import {produce} from "immer";
import type {CheckoutClothingService} from "@/scopes/checkout/domain/types/services/clothing";

interface ClothingServiceUpdateEditingPayload {
  participantId: string;
  value: string | null;
}

export function updateEditingClothingServiceValue(payload: ClothingServiceUpdateEditingPayload) {
  return produce((service: CheckoutClothingService) => {
    if (!payload.value) return;
    service.editingSelectedValues[payload.participantId].id = payload.value;
    service.editingSelectedValues[payload.participantId].value = service.options[payload.value].value;
    service.editingSelectedValues[payload.participantId].gender = service.options[payload.value].gender;
    service.editingSelectedValues[payload.participantId].size = service.options[payload.value].size;
  });
}

export function updateEditingClothingServiceGender(payload: ClothingServiceUpdateEditingPayload) {
  return produce((service: CheckoutClothingService) => {
    if (!payload.value) return;
    service.editingSelectedValues[payload.participantId].gender = payload.value;
    const matchedPreviousSize =  service.sizes[payload.value].sizes.find(size => size ===  service.editingSelectedValues[payload.participantId].size)
    if (matchedPreviousSize) {
      service.editingSelectedValues[payload.participantId].size = matchedPreviousSize;
    } else {
      service.editingSelectedValues[payload.participantId].size = 'NoSize';
    }


    const selectedOption = Object.values(service.options).find(option =>
      option.size === service.editingSelectedValues[payload.participantId].size &&
      option.gender === payload.value
    )
    service.editingSelectedValues[payload.participantId].id = selectedOption?.id || '';
  });
}

export function updateEditingClothingServiceSize(payload: ClothingServiceUpdateEditingPayload) {
  return produce((service: CheckoutClothingService) => {
    if (!payload.value) return;
    service.editingSelectedValues[payload.participantId].size = payload.value;

    const selectedOption = Object.values(service.options).find(option =>
      option.size === payload.value &&
      option.gender === service.editingSelectedValues[payload.participantId].gender
    )
    service.editingSelectedValues[payload.participantId].id = selectedOption?.id || '';
  });
}

export function saveEditingClothingServiceValue(payload: ClothingServiceUpdateEditingPayload) {
  return produce((service: CheckoutClothingService) => {
    service.participants[payload.participantId].selectedValue = payload.value;
  });
}
